import {setMetadata} from '../../../core/data-source/data-source';
import {CrudMethod, HttpCrudDataSource, RestResponseRecord} from '../../../core/data-source/http-crud.data-source';
import {fromJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';

export class OrderItemsDeliveryReportDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/reports/orderItemsReport';
    async list(options: any = {}): Promise<T[]> {
        return await httpService
            .get(
                this.getUrl(CrudMethod.LIST),
                // Object.assign(options, {
                {
                    transformResponse: (data: any) => {
                        return new Function(' return ' + data)();
                    }
                }
                // })
            )
            .then((response: any) => {
                return setMetadata(
                    response.data.reportRecords.map((v: any) => fromJson(this.recordClass, v)),
                    fromJson(RestResponseRecord, response.data)
                );
            });
    }

    exportReport(fileName: string): Window {
        const url: string =
            httpService.getBaseUrl() + this.apiPath + '/' + Date.now() + '/?type=Excel&fileName=' + fileName;
        const result: Window = window.open(url, '_blank');
        return result;
    }
}
